import { render, staticRenderFns } from "./TPAsearch.vue?vue&type=template&id=47c642bd&scoped=true&"
import script from "./TPAsearch.vue?vue&type=script&lang=js&"
export * from "./TPAsearch.vue?vue&type=script&lang=js&"
import style0 from "./TPAsearch.vue?vue&type=style&index=0&id=47c642bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c642bd",
  null
  
)

export default component.exports